// extracted by mini-css-extract-plugin
export default {"left":"CallToAction_left__nJ8r4","center":"CallToAction_center__jJLwo","right":"CallToAction_right__1j-q+"};